var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[(this.logged === true)?_c('toolbar-menu'):_vm._e(),_vm._v(" "),_c('v-content',[_c('transition',{attrs:{"name":"slide"}},[_c('router-view')],1)],1),_vm._v(" "),(this.logged === true)?_c('footer-menu'):_vm._e(),_vm._v(" "),_c('MigrationDialog')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd7e7e62","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 472
// module chunks = 1